import { readTextFile } from '../utils/readJson.js'
import { createAndAddGenericElement, getClassList, createImageElement, createCenteredUnderlinedText } from './generics.js'

const createLevelElements = (levelId, doorObj) => {
    if (!levelId && !doorObj) return
    if (doorObj.titleDiv) {
        const titleElement = createAndAddGenericElement(getClassList(doorObj.titleDiv), "", "", "", doorObj.titleDiv.element)
        if (doorObj.titleDiv.imageWrapper) {
            createImageElement(doorObj.titleDiv.imageWrapper, titleElement, true)
        }
        if (doorObj.titleDiv.header) {
            createAndAddGenericElement(getClassList(doorObj.titleDiv.header), "", titleElement, doorObj.titleDiv.header.text, doorObj.titleDiv.header.element)
        }
        levelId.appendChild(titleElement)
    }
    if (doorObj.paraWrapper) {
        const paraWrapperElement = createAndAddGenericElement(getClassList(doorObj.paraWrapper), "", "", "", doorObj.paraWrapper.element)
        createAndAddGenericElement(getClassList(doorObj.paraWrapper.para), "", paraWrapperElement, doorObj.paraWrapper.para.text, doorObj.paraWrapper.para.element)
        levelId.appendChild(paraWrapperElement)
    }
}

const createDoorWindowCard = (parentDiv, jsonFile, isCreateLargeDiv, jsonCardElement) => {
    let largeDiv = parentDiv
    if (isCreateLargeDiv) largeDiv = createAndAddGenericElement(["large"], "", parentDiv, "", "div")
    createLevelElements(largeDiv, jsonCardElement)
}

const loadCards = (sectionParentDiv, colClassList, cardObj, jsonFile, isCreateLargeDiv, jsonRootElement) => {
    if (!sectionParentDiv) return
    if (!colClassList) return
    if(!cardObj && !cardObj.cardTypePrefix &&  !cardObj.numCards && cardObj.classList) return
    readTextFile(jsonFile, function(readDoorsContent) {
        const doorsData = JSON.parse(readDoorsContent)
        const containerDiv = createAndAddGenericElement(["container", "client"], "", sectionParentDiv, "", "div")
        createCenteredUnderlinedText(doorsData.heading, "h2", containerDiv)
        const rowDiv = createAndAddGenericElement(["row"], "", containerDiv, "", "div")
        for (let i = 0; i < cardObj.numCards; ++i) {
            const colDiv = createAndAddGenericElement(colClassList, "", rowDiv, "", "div")
            const mainDiv = createAndAddGenericElement(["main"], "", colDiv, "", "div")
            const cardDiv = createAndAddGenericElement(cardObj.classList, "", mainDiv, "", "div")
            createDoorWindowCard(cardDiv, jsonFile, isCreateLargeDiv, doorsData[jsonRootElement][i])
        }
    })
}

export { loadCards }
